import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '调查取证',
    links: [
      { to: '/category/diaocha-fangfa', label: '奸情调查方法' },
      { to: '/category/zhengju-shouji', label: '婚外情证据收集' },
      { to: '/article/shouji-dingwei-zhuizong-jiqiao', label: '手机定位追踪技巧' },
      { to: '/article/si-jia-zhen-tan-de-hefa-bianjie', label: '私家侦探合法边界' },
    ],
  },
  {
    title: '法律维权',
    links: [
      { to: '/category/falv-weiquan', label: '法律维权路径' },
      { to: '/article/lihun-susong-zhong-de-zhengju-yunyong', label: '证据运用策略' },
      { to: '/article/caichan-baohu-lihun-qian-de-zhunbei', label: '财产保护实战' },
      { to: '/article/zinv-fuyang-quan-zhengyi-zhinan', label: '子女抚养权指南' },
    ],
  },
  {
    title: '心理支持',
    links: [
      { to: '/category/xinli-shudao', label: '心理疏导建议' },
      { to: '/category/hunyin-weiji', label: '婚姻危机处理' },
      { to: '/article/faxian-beipan-hou-de-xinli-tiaoshi', label: '心理调适指南' },
      { to: '/article/beipan-chuangshang-de-ziwo-xiufu', label: '自我修复建议' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about#testimonials', label: '用户口碑' },
      { to: '/about#contact', label: '联系我们' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center bg-primary-500 rounded">
              <i className="ri-scales-line text-background-50 text-xs"></i>
            </div>
            <span className="text-sm text-foreground-600">
              奸情调查取证全攻略 &copy; {new Date().getFullYear()}
            </span>
          </div>
          <p className="text-xs text-foreground-500">
            本站内容仅供信息参考，不构成法律建议。具体问题请咨询专业律师。
          </p>
        </div>
      </div>
    </footer>
  );
}